export enum SituacaoEnum {
  ATIVOS = 'ativo',
	INATIVOS = 'inativo'
}

export interface Situacao {
  nome: string;
  valor: SituacaoEnum;
}